export enum DrawingItemType {
	COUNT = "COUNT",
	LENGTH = "LENGTH",
	AREA = "AREA",
	TOP_VIEW_WALL_AREA = "TOP_VIEW_WALL_AREA",
	PEN = "PEN",
	TEXT = "TEXT",
	IMAGE = "IMAGE",
}

export enum PageSizeFormat {
	A0 = "A0",
	A1 = "A1",
	A2 = "A2",
	A3 = "A3",
	A4 = "A4",
	A5 = "A5",
}

export const DEFAULT_PAGE_SIZE = PageSizeFormat.A4;

export const isPageSizeFormat = (value: unknown): value is PageSizeFormat =>
	Object.values(PageSizeFormat).includes(value as PageSizeFormat);

export const resolvePageSize = (value: unknown): PageSizeFormat =>
	isPageSizeFormat(value) ? value : DEFAULT_PAGE_SIZE;

export enum CursorStyle {
	DEFAULT = "default",
	CROSSHAIR = "crosshair",
	MOVE = "move",
	POINTER = "pointer",
	SRESIZE = "s-resize",
	NOTALLOWED = "not-allowed",
}

export enum TextStyle {
	NORMAL = "normal",
	BOLD = "bold",
	ITALIC = "italic",
}

export enum TextAlign {
	CENTER = "center",
	LEFT = "left",
	RIGHT = "right",
}
